import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import NavLinks from "../../layouts/dashboard/Navlinks";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Logo from "../../assets/images/logo.png";
import { color } from "../../utils/constant";
import { useLocation, useNavigate } from "react-router-dom";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { Menu, MenuItem } from "@mui/material";
import { useAuth } from "../../data/talons/Authentication/useAuth";
import { enqueueSnackbar } from "notistack";
const drawerWidth = 240;
// const isSmallScreen = window.matchMedia("(max-width: 500px)").matches;
const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    paddingTop: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    overflow: "hidden",
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

export default function DashboardLayout({ children }) {
  const theme = useTheme();
  const { logout } = useAuth();
  const [open, setOpen] = React.useState(true);
  const [isSmallScreen, setIsSmallScreen] = React.useState(
    window.matchMedia("(max-width: 500px)").matches
  );

  const location = useLocation();
  const navigate = useNavigate();
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleMediaQueryChange = (event) => {
    setIsSmallScreen(event.matches);
  };
  const handleLogout = async () => {
    try {
      await logout();
      setAnchorEl(null);
      navigate("/");
    } catch (error) {
      console.error(error);
      enqueueSnackbar("Unable to logout!", { variant: "error" });
    }
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  React.useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 500px)");

    setOpen(!mediaQuery.matches);

    mediaQuery.addEventListener("change", handleMediaQueryChange);

    return () => {
      // Remove the event listener when component unmounts
      mediaQuery.removeEventListener("change", handleMediaQueryChange);
    };
  }, [isSmallScreen]);
  return (
    <Box
      sx={{
        display: "flex",
        // overflow: "hidden",
        width: "100%",
        // height: "100vh",
      }}
    >
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: color.button,
        }}
        open={open}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{ mr: 2, ...(open && { display: "none" }) }}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h5" noWrap component="div">
              {location.pathname === "/area"
                ? "Area"
                : location.pathname === "/doctor"
                  ? "Doctor"
                  : location.pathname === "/patient"
                    ? "Patient"
                    : location.pathname === "/doctor-holiday"
                      ? "Holidays"
                      : location.pathname === "/lab"
                        ? "Lab"
                        : location.pathname === "/faq"
                          ? "FAQ"
                          : location.pathname === "/help"
                            ? "Help"
                            : location.pathname === "/speciality"
                              ? "Speciality"
                              : location.pathname === "/review"
                                ? "Review"
                                : location.pathname === "/user-master"
                                  ? "User Master"
                                  : location.pathname === "/appointment"
                                    ? "Appointment"
                                    : location.pathname === "/doctor-availablity"
                                      ? "Availability"
                                      : location.pathname === "/leave-type"
                                        ? "Leave Type"
                                        : location.pathname === "/doctor-slot-block"
                                          ? "Slot Block"
                                          : "Dashboard"}
            </Typography>
          </div>
          <div>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <AccountCircle sx={{ fontSize: "40px" }} />
            </IconButton>
            <Menu
              sx={{ mt: "40px" }}
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              {/* <MenuItem
                onClick={() => {
                  navigate("/profile");
                  handleClose();
                }}
              >
                Profile
              </MenuItem> */}
              <Divider />
              <MenuItem sx={{ color: "red" }} onClick={handleLogout}>
                Logout
              </MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
        variant="persistent"
        anchor="left"
        open={open}
      >
        <DrawerHeader>
          <img src={Logo} alt="logo" width={"200px"} />
          <IconButton sx={{ p: 0.5 }} onClick={handleDrawerClose}>
            {theme.direction === "ltr" ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </DrawerHeader>

        <Divider />
        <NavLinks />
      </Drawer>
      <Main open={open}>
        <DrawerHeader />
        {children}
      </Main>
    </Box>
  );
}
